/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "キャンセル"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "顧客データにアクセスするための業務上の正当な理由を得ています"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "ダウンロードアクティビティは、セキュリティコンプライアンスの目的で記録および追跡されます"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "続行しますか？"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "ダウンロードすることで、次に同意したものとみなされます。"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
